import { render, staticRenderFns } from "./LightboxOverlay.vue?vue&type=template&id=446ac248&"
import script from "./LightboxOverlay.vue?vue&type=script&lang=js&"
export * from "./LightboxOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LightboxOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports